export default "__VITE_ASSET__o0FKg6H2__"